/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_Open_Easter_EggInputs */

const en_btn_open_easter_egg = /** @type {(inputs: Btn_Open_Easter_EggInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reveal the Final Surprise`)
};

const ar_btn_open_easter_egg = /** @type {(inputs: Btn_Open_Easter_EggInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اكشف المفاجأة الأخيرة`)
};

const de_btn_open_easter_egg = /** @type {(inputs: Btn_Open_Easter_EggInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enthüllen Sie die letzte Überraschung`)
};

const es_btn_open_easter_egg = /** @type {(inputs: Btn_Open_Easter_EggInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revela la sorpresa final`)
};

const fr_btn_open_easter_egg = /** @type {(inputs: Btn_Open_Easter_EggInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Révéler la Dernière Surprise`)
};

const it_btn_open_easter_egg = /** @type {(inputs: Btn_Open_Easter_EggInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rivela la sorpresa finale`)
};

const ja_btn_open_easter_egg = /** @type {(inputs: Btn_Open_Easter_EggInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最後のサプライズを開く`)
};

const ko_btn_open_easter_egg = /** @type {(inputs: Btn_Open_Easter_EggInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`마지막 깜짝 선물 보기`)
};

const pt_br_btn_open_easter_egg = /** @type {(inputs: Btn_Open_Easter_EggInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revelar a surpresa final`)
};

const ru_btn_open_easter_egg = /** @type {(inputs: Btn_Open_Easter_EggInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Раскрыть финальный сюрприз`)
};

const th_btn_open_easter_egg = /** @type {(inputs: Btn_Open_Easter_EggInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เปิดเผยเซอร์ไพรส์สุดท้าย`)
};

const tr_btn_open_easter_egg = /** @type {(inputs: Btn_Open_Easter_EggInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Son Sürprizi Açığa Çıkar`)
};

const zh_cn_btn_open_easter_egg = /** @type {(inputs: Btn_Open_Easter_EggInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开最终彩蛋`)
};

const zh_tw_btn_open_easter_egg = /** @type {(inputs: Btn_Open_Easter_EggInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打開最終彩蛋`)
};

/**
* | output |
* | --- |
* | "Reveal the Final Surprise" |
*
* @param {Btn_Open_Easter_EggInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const btn_open_easter_egg = /** @type {((inputs?: Btn_Open_Easter_EggInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_Open_Easter_EggInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_btn_open_easter_egg(inputs)
	if (locale === "ar") return ar_btn_open_easter_egg(inputs)
	if (locale === "de") return de_btn_open_easter_egg(inputs)
	if (locale === "es") return es_btn_open_easter_egg(inputs)
	if (locale === "fr") return fr_btn_open_easter_egg(inputs)
	if (locale === "it") return it_btn_open_easter_egg(inputs)
	if (locale === "ja") return ja_btn_open_easter_egg(inputs)
	if (locale === "ko") return ko_btn_open_easter_egg(inputs)
	if (locale === "pt_br") return pt_br_btn_open_easter_egg(inputs)
	if (locale === "ru") return ru_btn_open_easter_egg(inputs)
	if (locale === "th") return th_btn_open_easter_egg(inputs)
	if (locale === "tr") return tr_btn_open_easter_egg(inputs)
	if (locale === "zh_cn") return zh_cn_btn_open_easter_egg(inputs)
	return zh_tw_btn_open_easter_egg(inputs)
});